import { render, staticRenderFns } from "./DoanhThu.vue?vue&type=template&id=bcf73502&scoped=true&lang=true&"
import script from "./DoanhThu.vue?vue&type=script&lang=js&"
export * from "./DoanhThu.vue?vue&type=script&lang=js&"
import style0 from "./DoanhThu.vue?vue&type=style&index=0&id=bcf73502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf73502",
  null
  
)

export default component.exports